import createReactComponent from '../createReactComponent';
var ServerOff = createReactComponent('ServerOff', [['path', {
  d: 'M7 2h13a2 2 0 012 2v4a2 2 0 01-2 2h-5',
  key: 'y69iiv'
}], ['path', {
  d: 'M10 10L2.5 2.5C2 2 2 2.5 2 5v3a2 2 0 002 2h6z',
  key: '1lr4o5'
}], ['path', {
  d: 'M22 17v-1a2 2 0 00-2-2h-1',
  key: '8nkkse'
}], ['path', {
  d: 'M4 14a2 2 0 00-2 2v4a2 2 0 002 2h16.5l1-.5.5.5-8-8H4z',
  key: '1ltxgz'
}], ['path', {
  d: 'M6 18h.01',
  key: 'uhywen'
}], ['path', {
  d: 'M2 2l20 20',
  key: '48x37f'
}]]);
export default ServerOff;